import { useCallback } from 'react'

import { ThemeMode } from '@space-lib/styles/themes/enum'
import avatarDark from '@space-shell/assets/images/avatarDark.svg'
import avatarDefault from '@space-shell/assets/images/avatarDefault.svg'

import useThemeContext from '@space-shell/common/hooks/useThemeContext'

export const useThemeAvatar = () => {
  const { theme } = useThemeContext()

  const selectAvatar = useCallback(
    (avatar?: string) => {
      if (avatar) {
        return avatar
      }

      if (theme === ThemeMode.DARK) {
        return avatarDark
      }

      return avatarDefault
    },
    [theme]
  )

  return { selectAvatar }
}
